import {
  DC_REPORT_TYPE,
  DC_COMPANY,
  DC_KUARTAL,
  DC_YEAR,
  DC_DATA,
} from "../../../constants";
const initial = {
  year: new Date().getFullYear(),
  kuartal: 1,
  reportType: 1,
  data: [],
};
const drr = (state = initial, action) => {
  switch (action.type) {
    case DC_COMPANY:
      return {
        ...state,
        company: action.data?.id,
        companyName: action.data?.name,
      };
    case DC_YEAR:
      return {
        ...state,
        year: action.data,
      };
    case DC_REPORT_TYPE:
      return {
        ...state,
        reportType: action.data,
      };
    case DC_KUARTAL:
      return {
        ...state,
        kuartal: action.data,
      };
    case DC_DATA:
      return {
        ...state,
        data: action.data,
      };
    default:
      return { ...state };
  }
};
export default drr;
